import React, { useState } from "react";
import { Card, CardHeader, CardText } from "material-ui/Card";
import Avatar from "material-ui/Avatar";

const CategorizedItemList = ({ categories, items, ...rest }) => {
  return (
    <div>
      {categories.map(category => {
        const categoryItems = items.filter(o => o.category === category.id);
        if (categoryItems.length) {
          return (
            <CategoryOptionListItem
              key={`category-option-list-item-${category.id}`}
              options={categoryItems}
              category={category}
              {...rest}
            />
          );
        } else {
          return "";
        }
      })}
    </div>
  );
};

const CategoryOptionListItem = ({
  category,
  options,
  showIndicator,
  expandable,
  children,
  expanded
}) => {
  const [isExpanded, setExpanded] = useState(expandable ? !!expanded : true);
  showIndicator = showIndicator || (() => false);
  const indicatorVisible = showIndicator(options);
  return (
    <Card onExpandChange={() => setExpanded(!isExpanded)}>
      <CardHeader
        avatar={
          indicatorVisible ? (
            <Avatar backgroundColor="rgb(109, 178, 217)" size={10} />
          ) : (
            <Avatar
              style={{ border: "1px solid #d9d9d9" }}
              backgroundColor="white"
              size={10}
            />
          )
        }
        title={category.title}
        actAsExpander={expandable}
        showExpandableButton={expandable}
      />
      <CardText style={{ display: isExpanded ? "block" : "none" }}>
        {options.map(children)}
      </CardText>
    </Card>
  );
};

export default CategorizedItemList;
